<div class="toolbar bg-transparent">
  <div class="toolbar-left">
      <h1 style="margin-top: 20px;padding: 0;margin-bottom: 0;" [style.fontSize]="fontSize ">{{title}}</h1>
     <p style="font-size:small;font-weight: 400;padding: 0px;margin: 0;">{{subtitle}}</p> 
  </div>
  <span class="spacer"></span>
  <div class="toolbar-right"> 
  </div>
</div>